import { useDataSubmit } from 'Simple/Data'
import { useSetFlowTo, normalizePath } from 'Simple/Flow.js'

/** @type {import('Simple/types.js').useDataOnChange} */
export default function useDataOnChange(props, data) {
  let submit = useDataSubmit({
    context: 'app',
    viewPath: props.viewPath,
  })
  let setFlowTo = useSetFlowTo(props.viewPath)

  return async function onChange(value) {
    if (value === null) {
      await submit({ type: 'cancel-oauth2-authorization-code-connection' })
      setFlowTo(normalizePath(props.viewPath, '../../No'))
    } else if (value?.status === 'active' || value?.status === 'deleted') {
      // we mark a connection as deleted when the connection already existed
      await submit({ type: 'oauth2-authorization-code-connected' })
      setFlowTo(normalizePath(props.viewPath, '../../No'))
    }
  }
}
